<template>
  <div class="table-container-inner">
    <table>
      <thead>
      <tr class="tr-fixed-height">
        <th
            class="metall-received-count"
            scope="col"
            rowspan="4"
        >
          № п/п
        </th>
        <th
            class="metall-received-count"
            scope="col"
            rowspan="4"
        >
          Администратор (структурное подразделение)
        </th>
        <th
            class="metall-received-count"
            scope="col"
            rowspan="4"
        >
          Группа товаров
        </th>
        <th
            class="metall-received-count"
            scope="col"
            rowspan="4"
        >
          Код ТМЦ (согласно учетной системы)
        </th>
        <th
            class="metall-received-count"
            scope="col"
            rowspan="4"
        >
          Полное наименование ТМЦ
        </th>
        <th
            class="metall-received-count"
            scope="col"
            rowspan="3"
            colspan="2"
        >
          Основные средства/товарно-материальные ценности
        </th>
        <th
            class="metall-received-count"
            scope="col"
            rowspan="4"
        >
          Ед. изм.
        </th>
        <th
            class="metall-received-count"
            scope="col"
            rowspan="3"
            colspan="4"
        >
          Остатки за предыдущие фин.годы
        </th>
        <th
            class="metall-received-count"
            scope="col"
            rowspan="3"
            colspan="3"
        >
          Утвержденный годовой бюджет ТМЗ 2022 год
        </th>
        <th
            class="metall-received-count"
            style="border: none"
            scope="col"
            rowspan="1"
            colspan="9"
        ></th>
        <th
            class="metall-received-count"
            scope="col"
            rowspan="2"
            colspan="4"
        >
          Переведено в НВЛ
        </th>
        <th
            class="metall-received-count"
            scope="col"
            rowspan="2"
            colspan="4"
        >
          Переведено в НЛ
        </th>

        <th
            class="metall-received-count"
            scope="col"
            rowspan="2"
            colspan="4"
        >
          Остаток на конец отчетного месяца
        </th>
        <th
            class="metall-received-count"
            scope="col"
            rowspan="3"
            colspan="2"
        >
          ИТОГО ОСТАТОК
        </th>
        <th
            class="metall-received-count"
            scope="col"
            rowspan="3"
            colspan="2"
        >
          Аварийный запас / Страховой запас
        </th>
      </tr>
      <tr>
        <th colspan="4" rowspan="1">Поступило ТМЦ</th>
        <th colspan="5" rowspan="1">
          Использовано в производстве
        </th>
      </tr>
      <tr>
        <th colspan="2" rowspan="1">
          Поступления по переходящим договорам
        </th>
        <th colspan="2" rowspan="1">2022 год</th>
        <th colspan="2" rowspan="1">
          Остатки за предыдущие фин. годы
        </th>
        <th colspan="3" rowspan="1">2022 год</th>
        <th colspan="2" rowspan="1">
          Остатки за предыдущие фин. годы
        </th>
        <th colspan="2" rowspan="1">2022 год</th>
        <th colspan="2" rowspan="1">
          Остатки за предыдущие фин. годы
        </th>
        <th colspan="2" rowspan="1">2022 год</th>
        <th colspan="2" rowspan="1">
          Остатки за предыдущие фин. годы
        </th>
        <th colspan="2" rowspan="1">2022 год</th>
      </tr>
      <tr>
        <th>ОС</th>
        <th>ТМЦ</th>
        <th>Кол-во</th>
        <th>Цена</th>
        <th>Сумма</th>
        <th>Дата поступления</th>
        <th>Кол-во</th>
        <th>Цена</th>
        <th>Сумма</th>
        <th>Кол-во</th>
        <th>Сумма</th>
        <th>Кол-во</th>
        <th>Сумма</th>
        <th>Кол-во</th>
        <th>Сумма</th>
        <th>Кол-во</th>
        <th>Цена</th>
        <th>Сумма</th>
        <th>Кол-во</th>
        <th>Сумма</th>
        <th>Кол-во</th>
        <th>Сумма</th>
        <th>Кол-во</th>
        <th>Сумма</th>
        <th>Кол-во</th>
        <th>Сумма</th>
        <th>Кол-во</th>
        <th>Сумма</th>
        <th>Кол-во</th>
        <th>Сумма</th>
        <th>Кол-во</th>
        <th>Сумма</th>
        <th>Кол-во</th>
        <th>Сумма</th>
      </tr>
      </thead>
      <tbody
          v-for="(request, index) in this
            .liquidDemandReportRequest"
          :key="request.id"
      >
      <tr>
        <td>{{ index + 1 }}</td>
        <td>{{ request.abp }}</td>
        <td>{{ request.category }}</td>
        <td>{{ request.code_tmc }}</td>
        <td>{{ request.name_tmc }}</td>
        <td>{{ request.main_os }}</td>
        <td>{{ request.main_tmc }}</td>
        <td>{{ request.measure_unit }}</td>
        <td>
          {{
            request.remains_before_tmz_count
                | getNumberFormatTmz
          }}
        </td>
        <td v-if="!request.broken_years">
          {{
            request.remains_before_tmz_price
                | getNumberFormatTmz
          }}
        </td>
        <td v-else>---</td>
        <td>
          {{
            request.remains_before_tmz_sum
                | getNumberFormatTmz
          }}
        </td>
        <td v-if="!request.broken_years">
          {{
            request.remains_receipt_date | formatDateTwo
          }}
        </td>
        <td v-else>---</td>
        <td>
          {{
            request.approved_budget_count
                | getNumberFormatTmz
          }}
        </td>
        <td v-if="!request.broken_price">
          {{
            request.approved_budget_price
                | getNumberFormatTmz
          }}
        </td>
        <td v-else>---</td>
        <td>
          {{
            request.approved_budget_sum
                | getNumberFormatTmz
          }}
        </td>
        <td>
          {{
            request.come_tmc_count_old | getNumberFormatTmz
          }}
        </td>
        <td>
          {{ request.come_tmc_sum_old | getNumberFormatTmz }}
        </td>
        <td>
          {{ request.come_tmc_count | getNumberFormatTmz }}
        </td>
        <td>
          {{ request.come_tmc_sum | getNumberFormatTmz }}
        </td>
        <td>
          {{
            request.used_production_count_old
                | getNumberFormatTmz
          }}
        </td>
        <td>
          {{
            request.used_production_sum_old
                | getNumberFormatTmz
          }}
        </td>
        <td>
          {{
            request.used_production_count
                | getNumberFormatTmz
          }}
        </td>
        <td>
          {{
            request.used_production_price
                | getNumberFormatTmz
          }}
        </td>
        <td>
          {{
            request.used_production_sum
                | getNumberFormatTmz
          }}
        </td>

        <td>
          {{
            request.to_transferred_nvl_count_old
                | getNumberFormatTmz
          }}
        </td>
        <td>
          {{
            request.to_transferred_nvl_sum_old
                | getNumberFormatTmz
          }}
        </td>
        <td>
          {{
            request.to_transferred_nvl_count
                | getNumberFormatTmz
          }}
        </td>
        <td>
          {{
            request.to_transferred_nvl_sum
                | getNumberFormatTmz
          }}
        </td>

        <td>
          {{
            request.to_transferred_liquid_count_old
                | getNumberFormatTmz
          }}
        </td>
        <td>
          {{
            request.to_transferred_liquid_sum_old
                | getNumberFormatTmz
          }}
        </td>
        <td>
          {{
            request.to_transferred_liquid_count
                | getNumberFormatTmz
          }}
        </td>
        <td>
          {{
            request.to_transferred_liquid_sum
                | getNumberFormatTmz
          }}
        </td>

        <td>
          {{
            request.remains_after_tmz_count_old
                | getNumberFormatTmz
          }}
        </td>
        <td>
          {{
            request.remains_after_tmz_sum_old
                | getNumberFormatTmz
          }}
        </td>
        <td>
          {{
            request.remains_after_tmz_count
                | getNumberFormatTmz
          }}
        </td>
        <td>
          {{
            request.remains_after_tmz_sum
                | getNumberFormatTmz
          }}
        </td>

        <td>{{ request.total_count | getNumberFormatTmz }}</td>
        <td>{{ request.total_sum | getNumberFormatTmz }}</td>

        <td>{{ request.energy_stock_count | getNumberFormatTmz }}</td>
        <td>{{ request.energy_stock_sum | getNumberFormatTmz }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>


<script>
export default {
  props: ['report'],
  data() {
    return {
      liquidDemandReportRequest: ''
    }
  },
  watch: {
    report: function (newVal) {
      this.liquidDemandReportRequest = newVal
    }
  },
  mounted() {
    this.liquidDemandReportRequest = this.report
  }
}
</script>

<style scoped>
.table-container-inner {
  padding: 0.5rem;
  margin: 0 2rem;
  /* padding: 1rem 2rem; */
  /* margin-right: 2rem; */
  /* margin: 1rem 2rem; */
  max-height: 65vh;
  overflow: auto;
  max-width: 100vw;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin: 0 auto 2rem;
  overflow-x: auto;
  border-bottom: 1px solid black;
  font-size: 14px;
}

th,
td {
  border: 1px solid #868686;
  padding: 0 1rem;
}
</style>
